// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/waveService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  WaveDavDisponivel, WaveResumo, WaveDetalhe, WavePackItem, WavePedido,
  CriarWaveRequest, ConferirPedidoRequest,
} from '../types';

const BASE = '/api/waves';

export const waveService = {
  async disponiveis(): Promise<WaveDavDisponivel[]> {
    const { data } = await apiClient.get<WaveDavDisponivel[]>(`${BASE}/disponiveis`);
    return data;
  },
  async getAll(): Promise<WaveResumo[]> {
    const { data } = await apiClient.get<WaveResumo[]>(BASE);
    return data;
  },
  async getById(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.get<WaveDetalhe>(`${BASE}/${id}`);
    return data;
  },
  async create(req: CriarWaveRequest): Promise<WaveDetalhe> {
    const { data } = await apiClient.post<WaveDetalhe>(BASE, req);
    return data;
  },
  async iniciarSeparacao(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/iniciar-separacao`, {});
    return data;
  },
  async concluirSeparacao(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/concluir-separacao`, {});
    return data;
  },
  async distribuir(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/distribuir`, {});
    return data;
  },
  async cancelar(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/cancelar`, {});
    return data;
  },
  async itensPedido(waveId: number, pedidoId: number): Promise<WavePackItem[]> {
    const { data } = await apiClient.get<WavePackItem[]>(`${BASE}/${waveId}/pedidos/${pedidoId}/itens`);
    return data;
  },
  async conferir(waveId: number, pedidoId: number, req: ConferirPedidoRequest): Promise<WavePedido> {
    const { data } = await apiClient.post<WavePedido>(`${BASE}/${waveId}/pedidos/${pedidoId}/conferir`, req);
    return data;
  },
};
